import React from 'react';

/**
 * StepFlowGraphic — Visual illustrations for "How it works" steps.
 * Pure SVG mini-illustrations that replace plain numbered circles.
 */

export function StepEnvelope() {
  return (
    <div className="v2-step-graphic">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        {/* Envelope body */}
        <rect x="8" y="18" width="48" height="32" rx="4" stroke="var(--v2-green, #28b6c8)" strokeWidth="2" fill="none" />
        {/* Envelope flap */}
        <path d="M8 22l24 16 24-16" stroke="var(--v2-green, #28b6c8)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        {/* @ symbol hint */}
        <circle cx="32" cy="36" r="4" stroke="var(--v2-muted, #888)" strokeWidth="1.5" fill="none" opacity="0.5" />
        {/* Send sparkle */}
        <circle cx="52" cy="16" r="2" fill="var(--v2-green, #28b6c8)" opacity="0.6" />
        <circle cx="56" cy="12" r="1.2" fill="var(--v2-green, #28b6c8)" opacity="0.4" />
      </svg>
    </div>
  );
}

export function StepIdVerify() {
  return (
    <div className="v2-step-graphic">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        {/* ID Card */}
        <rect x="6" y="16" width="36" height="26" rx="3" stroke="var(--v2-green, #28b6c8)" strokeWidth="2" fill="none" />
        {/* Photo placeholder */}
        <rect x="10" y="21" width="10" height="12" rx="2" stroke="var(--v2-muted, #888)" strokeWidth="1.5" fill="none" opacity="0.5" />
        {/* Text lines on ID */}
        <line x1="24" y1="24" x2="38" y2="24" stroke="var(--v2-muted, #888)" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="24" y1="29" x2="34" y2="29" stroke="var(--v2-muted, #888)" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="24" y1="34" x2="36" y2="34" stroke="var(--v2-muted, #888)" strokeWidth="1.5" strokeLinecap="round" opacity="0.3" />
        {/* Selfie circle */}
        <circle cx="50" cy="28" r="10" stroke="var(--v2-green, #28b6c8)" strokeWidth="2" fill="none" />
        {/* Face hint */}
        <circle cx="50" cy="26" r="3" stroke="var(--v2-muted, #888)" strokeWidth="1.5" fill="none" opacity="0.5" />
        <path d="M44 34 a6 4 0 0 1 12 0" stroke="var(--v2-muted, #888)" strokeWidth="1.5" fill="none" opacity="0.3" />
        {/* Check mark */}
        <circle cx="54" cy="40" r="6" fill="var(--v2-green, #28b6c8)" opacity="0.15" />
        <path d="M51 40l2 2 4-4" stroke="var(--v2-green, #28b6c8)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}

export function StepReport() {
  return (
    <div className="v2-step-graphic">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        {/* Document */}
        <path d="M14 8h24l12 12v36a2 2 0 01-2 2H14a2 2 0 01-2-2V10a2 2 0 012-2z" stroke="var(--v2-green, #28b6c8)" strokeWidth="2" fill="none" />
        {/* Fold corner */}
        <path d="M38 8v12h12" stroke="var(--v2-green, #28b6c8)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        {/* Mini gauge arc */}
        <path d="M22 32 a8 8 0 0 1 16 0" stroke="var(--v2-green, #28b6c8)" strokeWidth="2.5" strokeLinecap="round" fill="none" />
        <path d="M22 32 a8 8 0 0 1 12.5-2" stroke="#16A34A" strokeWidth="2.5" strokeLinecap="round" fill="none" />
        {/* Score text */}
        <text x="30" y="38" textAnchor="middle" fontSize="6" fontWeight="700" fill="var(--v2-text, #1f2638)">742</text>
        {/* Text lines */}
        <line x1="18" y1="44" x2="44" y2="44" stroke="var(--v2-muted, #888)" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="18" y1="49" x2="38" y2="49" stroke="var(--v2-muted, #888)" strokeWidth="1.5" strokeLinecap="round" opacity="0.3" />
        {/* Risk badge */}
        <rect x="18" y="24" width="24" height="5" rx="2.5" fill="rgba(16,185,129,0.15)" />
        <text x="30" y="28" textAnchor="middle" fontSize="3.5" fontWeight="700" fill="#10b981">LOW RISK</text>
      </svg>
    </div>
  );
}

/**
 * StepConnector — Dotted line between steps (hidden on mobile via CSS)
 */
export function StepConnector() {
  return (
    <div className="v2-step-connector-line">
      <svg width="40" height="4" viewBox="0 0 40 4">
        <line x1="0" y1="2" x2="40" y2="2" stroke="var(--v2-green, #28b6c8)" strokeWidth="2" strokeDasharray="4 4" strokeLinecap="round" opacity="0.4" />
      </svg>
    </div>
  );
}
